import { IdentifiableOption } from "@/models/models";

export const tabs: IdentifiableOption[] = [
  { id: 0, name: "Beats" },
  { id: 1, name: "Songs" },
  { id: 2, name: "Sound Kits" },
];
